<template>
  <div>
    <label>Periodo</label>
    <datepicker
      :class="[customWidth]"
      name="period"
      :language="es"
      v-model="period"
      minimum-view="month"
      maximum-view="month"
      full-month-name
      :format="customFormatter"
      @selected="setDate"
      :disabled-dates="disabledDates"
    />
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import { es } from 'vuejs-datepicker/dist/locale';

export default {
  name: 'PeriodFilter',
  props: ['customWidth'],
  components: { Datepicker },
  data() {
    return {
      es,
      period: null
    };
  },
  computed: {
    disabledDates() {
      let from = null;
      const today = new Date();
      const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      if (today.getMonth() === lastDay.getMonth() && today.getDate() <= lastDay.getDate()) {
        from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      }
      return {
        from,
      };
    }
  },
  methods: {
    formatPeriod(date) {
      return `${this.$moment(date).format('YYYY-MM')}`;
    },
    customFormatter(date) {
      // El nombre que se ve en el input: septiembre 2021
      return this.$moment(date).format('MMMM YYYY');
    },
    getDefaultPeriod() {
      const date = new Date();
      const firtsDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
      return firtsDay;
    },
    setDate(date) {
      this.$emit('changePeriod', {
        type: 'periodo',
        filter: this.formatPeriod(date)
      });
    }
  },
  created() {
    this.period = this.getDefaultPeriod();
  }
};
</script>
